import pino from 'pino'

export default pino({ base: null, useLevelLabels: true })
